import React, { useState } from 'react';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { Typography, IconButton, Card, Menu, MenuItem, ListItemIcon } from '@mui/material'
import { AgChartsReact } from 'ag-charts-react';
// import DeleteConfirmation from '../DeleteConfirmation';

export default function SummaryWidget(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [show, setShow] = useState(false);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
		//setDeleteDialog(false)
	};
	//const [jan, feb, mar, apr, may, jun, jul, aug, sep, oct, nov, dec] = props.categoryBudget
	
	// const [options, setOptions] = useState({
	// 	autoSize: true,
	// 	theme: {
	// 		baseTheme: 'ag-default-dark',
	// 		overrides: {
	// 			line: {
	// 				background: {
	// 					fill: '#2A2E32'
	// 				}
	// 			}
	// 		}
	// 	},
	// 	data: [
	// 	  {
	// 		month: 'Jan',
	// 		forecastValue: jan?.forecastValue,
	// 		nfzeMarketingValue: jan?.nfzeMarketingValue,
	// 		partnerMarketingValue: jan?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'Fab',
	// 		forecastValue: feb?.forecastValue,
	// 		nfzeMarketingValue: feb?.nfzeMarketingValue,
	// 		partnerMarketingValue: feb?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'Mar',
	// 		forecastValue: mar?.forecastValue,
	// 		nfzeMarketingValue: mar?.nfzeMarketingValue,
	// 		partnerMarketingValue: mar?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'Apr',
	// 		forecastValue: apr?.forecastValue,
	// 		nfzeMarketingValue: apr?.nfzeMarketingValue,
	// 		partnerMarketingValue: apr?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'May',
	// 		forecastValue: may?.forecastValue,
	// 		nfzeMarketingValue: may?.nfzeMarketingValue,
	// 		partnerMarketingValue: may?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'Jun',
	// 		forecastValue: jun?.forecastValue,
	// 		nfzeMarketingValue: jun?.nfzeMarketingValue,
	// 		partnerMarketingValue: jun?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'Jul',
	// 		forecastValue: jul?.forecastValue,
	// 		nfzeMarketingValue: jul?.nfzeMarketingValue,
	// 		partnerMarketingValue: jul?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'Aug',
	// 		forecastValue: aug?.forecastValue,
	// 		nfzeMarketingValue: aug?.nfzeMarketingValue,
	// 		partnerMarketingValue: aug?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'Sep',
	// 		forecastValue: sep?.forecastValue,
	// 		nfzeMarketingValue: sep?.nfzeMarketingValue,
	// 		partnerMarketingValue: sep?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'Oct',
	// 		forecastValue: oct?.forecastValue,
	// 		nfzeMarketingValue: oct?.nfzeMarketingValue,
	// 		partnerMarketingValue: oct?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'Nov',
	// 		forecastValue: nov?.forecastValue,
	// 		nfzeMarketingValue: nov?.nfzeMarketingValue,
	// 		partnerMarketingValue: nov?.partnerMarketingValue
	// 	  },
	// 	  {
	// 		month: 'Dec',
	// 		forecastValue: dec?.forecastValue,
	// 		nfzeMarketingValue: dec?.nfzeMarketingValue,
	// 		partnerMarketingValue: dec?.partnerMarketingValue
	// 	  },
	// 	],
	// 	series: [
	// 	  {
	// 		xKey: 'month',
	// 		yKey: 'forecastValue',
	// 	  },
	// 	  {
	// 		xKey: 'month',
	// 		yKey: 'nfzeMarketingValue',
	// 	  },
	// 	  {
	// 		xKey: 'month',
	// 		yKey: 'partnerMarketingValue',
	// 	  },
	// 	],
	// });
  return (
    <>
		<Card className="relative flex flex-col flex-auto rounded-2xl shadow overflow-hidden">
			<div className='p-24 pr-12 pb-12'>
			<div className="flex items-center justify-between">
				<div className='flex flex-col'>
					<Typography variant="body1" className="text-lg font-medium tracking-tight leading-6 truncate">
						{props.categoryName}
					</Typography>
				</div>
				<div className='-mt-8'>
					<IconButton
						onClick={handleClick}
						aria-controls={open ? 'account-menu' : undefined}
						aria-haspopup="true"
						aria-expanded={open ? 'true' : undefined}>
						<FuseSvgIcon>heroicons-outline:dots-vertical</FuseSvgIcon>
					</IconButton>
					<Menu
						anchorEl={anchorEl}
						id="account-menu"
						open={open}
						onClose={handleClose}
						onClick={handleClose}
						PaperProps={{
							elevation: 0,
							sx: {
								overflow: 'visible',
								filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
								mt: 1.5,
								'& .MuiAvatar-root': {
									width: 32,
									height: 32,
									ml: -0.5,
									mr: 1,
								},
								'&:before': {
									content: '""',
									display: 'block',
									position: 'absolute',
									top: 0,
									right: 14,
									width: 10,
									height: 10,
									bgcolor: 'background.paper',
									transform: 'translateY(-50%) rotate(45deg)',
									zIndex: 0,
								},
							},
						}}
						transformOrigin={{ horizontal: 'right', vertical: 'top' }}
						anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
					>
						<MenuItem onClick={() => {
							props.setTableName(props.categoryName)
							props.handleChange()
						}}>
							See All {props.categoryName}
						</MenuItem>
					</Menu>
				</div>
			</div>
			<div className='flex flex-row flex-wrap mt-16 -mx-24'>
				<div className='flex flex-col mx-24 my-12'>
					<Typography className="text-sm font-medium leading-none">
						Retail Sales Total
					</Typography>
					<Typography className="mt-8 font-medium text-3xl leading-none">
					€{props.categoryBudget.totalForecastValue}
					</Typography>
				</div>
				<div className='flex flex-col mx-24 my-12'>
					<Typography className="text-sm font-medium leading-none">
						Partner Total
					</Typography>
					<Typography className="mt-8 font-medium text-3xl leading-none">
					€{props.categoryBudget.totalPartnerMarketingValue}
					</Typography>
				</div>
				<div className='flex flex-col mx-24 my-12'>
					<Typography className="text-sm font-medium leading-none">
						Noltefze Total
					</Typography>
					<Typography className="mt-8 font-medium text-3xl leading-none">
					€{props.categoryBudget.totalNfzeMarketingValue}
					</Typography>
				</div>
			</div>
			</div>
			{/*{show && <div className="w-100-p">
			 	 <AgChartsReact options={options} /> 
			</div>} */}
		</Card>
		</>
  )
}
